import AllergyConfig from "@/views/configs/allergy/index.vue";

export default [
  {
    path: "alergias",
    name: "Alergias",
    component: AllergyConfig,
  },
];
